const Config = {
  NavbarStateCookieName: 'tt-navbar-state',
  NavbarStateCookieOpenValue: 'open' as const,
  NavbarStateCookieClosedValue: 'closed' as const,
};

export { Config };
